import { useTranslation } from "react-i18next";
import { parseContentAddress } from "../../shared/references/contentReferences";
import { segmentDisplayName } from "../sources/document/documentNames";
import type { IndexedAnnotation } from "./annotationPlacement";
import { SpanProblems } from "./AnnotationSpanList";

interface UnplacedAnnotationsProps {
  annotations: readonly IndexedAnnotation[];
  labelNames: ReadonlyMap<string, string>;
  problems: ReadonlyMap<number, readonly string[]>;
}

/** Annotations the text can't show: their label, quote and segment, as v1 listed them. */
export default function UnplacedAnnotations({ annotations, labelNames, problems }: UnplacedAnnotationsProps) {
  const { t } = useTranslation();
  if (annotations.length === 0) {
    return null;
  }
  return (
    <div className="text-xs">
      <p className="app-text-muted">{t("threads.output.annotationsUnplaced")}</p>
      <ul className="space-y-0.5">
        {annotations.map(({ index, annotation }) => {
          const segmentPath = parseContentAddress(annotation.segment)?.segmentPath ?? null;
          return (
            <li key={index}>
              {labelNames.get(annotation.label) ?? annotation.label}: <q>{annotation.quote}</q>
              {segmentPath === null ? null : <span className="app-text-muted" title={annotation.segment}> ({segmentDisplayName(segmentPath)})</span>}
              {annotation.note === "" ? null : <span className="app-text-muted"> {annotation.note}</span>}
              <SpanProblems reasons={problems.get(index)} />
            </li>
          );
        })}
      </ul>
    </div>
  );
}
